import React from "react";
import LoanScheduleComponent from "./LoanScheduleComponent";
import {AppapproDTO} from "@/shared/api/model";
import { useProductPropertiesById } from "@/modules/loan-product-settings/hooks/useProductProperties";

interface LoanScheduleViewProps {
    data?: {
        valueData: AppapproDTO;
    };
    formikProps?: any;
}

const LoanScheduleView: React.FC<LoanScheduleViewProps> = ({ data, formikProps }) => {
    const values = formikProps?.values || data || {};
    const valueData = values.valueData as AppapproDTO;

    const glNo = valueData?.glNo ?? undefined;
    const { data: productPropertiesResponse } = useProductPropertiesById(glNo);
    const installmentRoundingPrecision = (productPropertiesResponse?.data as any)?.installmentRoundingPrecision ?? null;

    return <LoanScheduleComponent appapproDTO={valueData} installmentRoundingPrecision={installmentRoundingPrecision} />;
};

export default LoanScheduleView;